var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticStyle:{"overflow":"hidden"},attrs:{"name":_vm.name,"maxWidth":600,"width":"90%","height":"auto","adaptive":true}},[_c('resource',{staticClass:"m-0",attrs:{"resource":"transaction","resourceName":"Manuelle Transaktion","attributes":[
      {
        name: 'customer_profile_id',
        value: _vm.model.id,
        type: 'hidden'
      },
      {
        name: 'amount',
        placeholder:
          'Wie viele ' + _vm.currency + ' sollen gutgeschrieben werden?',
        type: 'InputSelector'
      },
      {
        name: 'price',
        placeholder: 'Wie viele € wurden für den Kauf bezahlt?',
        type: 'InputSelector'
      },
      {
        name: 'service',
        nullValue: 'Zu welcher Bezahlmethode soll dies verbucht werden?',
        type: 'DropdownSelector',
        items: _vm.options
      }
    ]},on:{"resource-persisted":function($event){return _vm.$modal.hide(_vm.name)}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("Zahlung für "+_vm._s(_vm.model.name)+" eintragen")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }